import * as ngCore from '@angular/core'

// TODO: Rework inputs ASAP
/**
 * Basic text input.
 *
 *  **Inputs**
 * - {@link AtnDsTextComponent._placeholder|placeholder}?
 * - {@link AtnDsTextComponent._value|value}?
 * - {@link AtnDsTextComponent._disabled|disabled}?
 * - {@link AtnDsTextComponent._label|label}?
 * - {@link AtnDsTextComponent._loading|loading}?
 *
 * **Outputs**
 * - {@link AtnDsTextComponent.change|change}
 * - {@link AtnDsTextComponent.input|input}
 *
 * @example
 * ```html
 * <atn-ds-text
 *   [placeholder]="'Enter text'"
 *   [loading]="false"
 *   [value]="inputValue"
 *   [disabled]="false"
 *   [label]="'Text Input'"
 *   (change)="handleChange($event)"
 *   (input)="handleInput($event)"
 * ></atn-ds-text>
 * ```
 */
@ngCore.Component({
  selector: 'atn-ds-text',
  standalone: true,
  styleUrls: ['./text.component.scss'],
  templateUrl: './text.component.html',
})
export class AtnDsTextComponent {
  /**
   * Placeholder text
   */
  public readonly placeholderSg = ngCore.input<string | undefined>('', {
    alias: 'placeholder',
  })

  /**
   * Whether the input is loading
   */
  public readonly loadingSg = ngCore.input<boolean | undefined>(false, {
    alias: 'loading',
  })

  /**
   * Input value
   */
  public valueSg = ngCore.input<string | undefined>(undefined, {
    alias: 'value',
  })

  /**
   * Whether the input is disabled
   */
  public disabledSg = ngCore.input<boolean | undefined>(false, {
    alias: 'disabled',
  })

  /**
   * Whether the input is disabled
   */
  public hasBorderSg = ngCore.input<boolean | undefined>(true, {
    alias: 'hasBorder',
  })

  /**
   * Input label
   */
  public labelSg = ngCore.input<string | undefined>(undefined, {
    alias: 'label',
  })

  /**
   * Event emitted when the input value changes.
   */
  public readonly change = ngCore.output<string | undefined>()

  /**
   * Event emitted when the input value changes.
   */
  public readonly input = ngCore.output<string>({
    alias: 'onInput',
  })

  public onChangeHandler(event: Event): void {
    event.stopPropagation()
    const target = event.target as HTMLInputElement | null
    this.change.emit(target?.value?.toString() ?? undefined)
  }
}
